module.exports = __webpack_public_path__ + "img/miniPro_judai_yingji.39670bf2.png";